import { ColumnsType } from 'antd/lib/table';
import {
  OptionProps,
  ProjectDurationRow,
  ReportsFilters,
  ReportsSortBy,
} from '@models/interfaces';
import { getProjectDurationSortableColumn, renderValue } from './common';

export const getProjectDurationColumns = (
  filters: ReportsFilters,
  sortByOptions: OptionProps[],
): ColumnsType<ProjectDurationRow> => [
  getProjectDurationSortableColumn(
    'durationDays',
    'Duration Days',
    ReportsSortBy.DurationDays,
    filters,
    sortByOptions,
    renderValue,
  ),
  {
    dataIndex: 'startDate',
    key: 'startDate',
    render: renderValue,
    title: 'Project Assigned Date',
  },
  {
    dataIndex: 'endDate',
    key: 'endDate',
    render: renderValue,
    title: 'Actual Date',
  },
  getProjectDurationSortableColumn(
    'projectBundleID',
    'Project Bundle ID',
    ReportsSortBy.ProjectBundleID,
    filters,
    sortByOptions,
    renderValue,
  ),
  {
    dataIndex: 'fuzeIDsDisplay',
    key: 'fuzeIDsDisplay',
    render: renderValue,
    title: 'Fuze IDs',
  },
  {
    dataIndex: 'psProjectNumbersDisplay',
    key: 'psProjectNumbersDisplay',
    render: renderValue,
    title: 'PS Project Numbers',
  },
  getProjectDurationSortableColumn(
    'projectType',
    'Project Type',
    ReportsSortBy.ProjectType,
    filters,
    sortByOptions,
    renderValue,
  ),
  {
    dataIndex: 'projectSubtype',
    key: 'projectSubtype',
    render: renderValue,
    title: 'Project Subtype',
  },
  getProjectDurationSortableColumn(
    'projectStatus',
    'Project Status',
    ReportsSortBy.ProjectStatus,
    filters,
    sortByOptions,
    renderValue,
  ),
  getProjectDurationSortableColumn(
    'progressStatus',
    'Progress Status',
    ReportsSortBy.ProgressStatus,
    filters,
    sortByOptions,
    renderValue,
  ),
  getProjectDurationSortableColumn(
    'siteName',
    'Site Name',
    ReportsSortBy.SiteName,
    filters,
    sortByOptions,
    renderValue,
  ),
  {
    dataIndex: 'psLocationCode',
    key: 'psLocationCode',
    render: renderValue,
    title: 'PS Location Code',
  },
  {
    dataIndex: 'mdgLocationCode',
    key: 'mdgLocationCode',
    render: renderValue,
    title: 'MDG Location Code',
  },
  {
    dataIndex: 'state',
    key: 'state',
    render: renderValue,
    title: 'State',
  },
  {
    dataIndex: 'submarket',
    key: 'submarket',
    render: renderValue,
    title: 'Submarket',
  },
  {
    dataIndex: 'towerOwner',
    key: 'towerOwner',
    render: renderValue,
    title: 'Tower Owner',
  },
];

export const getProjectDurationReportRowClassName = (
  record: ProjectDurationRow,
): string =>
  record.projectBundleID
    ? 'prov-project-duration-report__row--clickable'
    : 'prov-project-duration-report__row--disabled';

export const getProjectDurationReportRowKey = (
  record: ProjectDurationRow,
): string =>
  [record.projectId, record.projectBundleID, record.startDate, record.endDate]
    .filter(Boolean)
    .join('-');
